import { trackEvent } from './analytics';

/**
 * Landing Page Conversion Tracking
 * Track all signup-related actions to measure optimization effectiveness
 */

// Hero CTA clicks
export const trackHeroSignupClick = () => {
  trackEvent('cta_click', {
    cta_location: 'hero',
    cta_type: 'signup',
    button_text: 'Start Free Today'
  });
};

export const trackHeroCoursesClick = () => {
  trackEvent('cta_click', {
    cta_location: 'hero',
    cta_type: 'browse_courses',
    button_text: 'Browse Courses'
  });
};

// Google OAuth tracking
export const trackGoogleAuthClick = () => {
  trackEvent('oauth_initiated', {
    provider: 'google',
    location: 'signup_page'
  });
};

export const trackGoogleAuthSuccess = (userEmail) => {
  trackEvent('oauth_success', {
    provider: 'google',
    method: 'google_oauth'
  });
  
  // Also track as signup conversion
  trackEvent('sign_up', {
    method: 'google',
    subscription_tier: 'free'
  });
};

export const trackGoogleAuthFail = (error) => {
  trackEvent('oauth_failure', {
    provider: 'google',
    error_message: error
  });
};

// Chat Widget tracking
export const trackChatWidgetOpen = () => {
  trackEvent('chat_widget_opened', {
    widget_type: 'pre_signup_ai',
    event_category: 'engagement'
  });
};

export const trackChatWidgetMessage = (messageNumber) => {
  trackEvent('chat_message_sent', {
    message_number: messageNumber,
    max_messages: 3,
    event_category: 'engagement'
  });
};

export const trackChatWidgetSignupCTA = () => {
  trackEvent('chat_signup_cta_shown', {
    trigger: 'message_limit_reached',
    event_category: 'conversion_funnel'
  });
};

export const trackChatWidgetSignupClick = () => {
  trackEvent('cta_click', {
    cta_location: 'chat_widget',
    cta_type: 'signup',
    source: 'chat_limit_reached'
  });
};

// AI Companion section tracking
export const trackAICompanionCTAClick = () => {
  trackEvent('cta_click', {
    cta_location: 'ai_companion_section',
    cta_type: 'signup',
    button_text: 'Meet Your Christian AI Companion'
  });
};

// Course clicks
export const trackCourseCardClick = (courseName) => {
  trackEvent('course_card_click', {
    course_name: courseName,
    event_category: 'engagement'
  });
};

export const trackViewAllCoursesClick = () => {
  trackEvent('cta_click', {
    cta_location: 'courses_section',
    cta_type: 'view_all_courses'
  });
};

// Exit Intent Popup
export const trackExitIntentShown = () => {
  trackEvent('exit_intent_shown', {
    trigger: 'mouse_exit_top',
    event_category: 'conversion_funnel'
  });
};

export const trackExitIntentSignupClick = () => {
  trackEvent('cta_click', {
    cta_location: 'exit_intent_popup',
    cta_type: 'signup',
    source: 'exit_intent'
  });
};

export const trackExitIntentClose = () => {
  trackEvent('exit_intent_closed', {
    event_category: 'engagement'
  });
};

// Final CTA tracking
export const trackFinalCTAClick = () => {
  trackEvent('cta_click', {
    cta_location: 'final_cta',
    cta_type: 'signup',
    button_text: 'Start Your Journey Today'
  });
};

// Social Proof engagement
export const trackSocialProofView = () => {
  trackEvent('social_proof_viewed', {
    type: 'live_activity_feed',
    event_category: 'engagement'
  });
};

// Trust badge impressions
export const trackTrustBadgesView = () => {
  trackEvent('trust_badges_viewed', {
    event_category: 'engagement'
  });
};

// Overall page engagement
export const trackLandingPageEngagement = (timeSpent) => {
  trackEvent('page_engagement', {
    time_spent_seconds: timeSpent,
    page_path: '/landing',
    event_category: 'engagement'
  });
};

// Form submission tracking (for regular signup)
export const trackSignupFormStart = () => {
  trackEvent('form_start', {
    form_name: 'signup',
    event_category: 'conversion_funnel'
  });
};

export const trackSignupFormSubmit = () => {
  trackEvent('form_submit', {
    form_name: 'signup',
    event_category: 'conversion_funnel'
  });
};

export const trackSignupFormSuccess = (subscriptionTier = 'free') => {
  trackEvent('sign_up', {
    method: 'email',
    subscription_tier: subscriptionTier
  });
  
  // Also track as conversion
  trackEvent('conversion', {
    conversion_type: 'signup',
    conversion_value: 0,
    currency: 'USD'
  });
};

export const trackSignupFormError = (errorMessage) => {
  trackEvent('form_error', {
    form_name: 'signup',
    error_message: errorMessage,
    event_category: 'error'
  });
};
